import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  font-size: 16px;\n  font-style: italic;\n  margin-bottom: 1em;\n\n  @media screen and (max-width: ', ') {\n    font-size: 12px;\n  }\n'], ['\n  font-size: 16px;\n  font-style: italic;\n  margin-bottom: 1em;\n\n  @media screen and (max-width: ', ') {\n    font-size: 12px;\n  }\n']);

import styled from 'styled-components';

export var StyledPdpMessage = styled.div(_templateObject, function (props) {
  return props.theme.tabletWidth;
});